import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';

/**
 * for this page
 */

class HeadLine extends React.PureComponent {
    static propTypes = {
        content: PropTypes.object,
    };

    state = {};

    render() {
        const { content } = this.props;

        return (
            <div className={styles.headLine}>
                <div className={styles.inner}>
                    <h1>{content.title}</h1>
                    <p>
                        <span>{content.id === '7238804267421667328' ? '' : '发布时间：'}</span>
                        <span>{content.id === '7238804267421667328' ? '' : content.createtime}</span>
                        <span className={content.id === '7238804267421667328' ? '' : styles.pl24}>{Number(content.expire) ? '调查进行中' : '调查已结束'}</span>
                        <span className={styles.pl24}>
                            <strong className={styles.cRed2}>
                                <span className={styles.num}>{content.pnum}</span>
                            </strong>人参与
                        </span>
                    </p>
                </div>
            </div>
        );
    }
}

export default HeadLine;
